import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";

import { PayloadAction } from "@reduxjs/toolkit";
import { IReExamlistID } from "../../../Pages/Exam/IExam";
import { failurelistReExamID, successlistReExamID } from "./ListReExamSlice";

// list exam id

const ListReExamIDApi = (action: PayloadAction<IReExamlistID>) => {
  const { id } = action.payload; // Extract id, ignore callbacks
  return api.get("/api/exam/retakeTest", { params: { id } });
};

export function* ListReExamIDCall(action: PayloadAction<IReExamlistID>) {
  try {
    const response: AxiosResponse = yield call(ListReExamIDApi, action);
    yield put(successlistReExamID(response.data));
    if (action.payload.onSuccess) {
      action.payload.onSuccess(response.data);
    }
  } catch (error) {
    yield put(failurelistReExamID(error));
    if (action.payload.onFailure) {
      action.payload.onFailure(error);
    }
  }
}
